import '../styles/index.scss';

import ReactComponents from './components/react-components';
import CurrencyRedirect from './components/currency-redirect';
import PageHeader from './components/page-header';
import MegaMenu from './components/mega-menu';
import HeroHeader from './components/hero-header';
import HeroSwiper from './components/hero-swiper';
import RangeFilterOverrides from './components/range-filter-overrides';
import MaterialSwiper from './components/material-swiper';
import PDPFurniture from './components/pdp-f';
import PDP from './components/pdp';
import CardSwiper from './components/card-swiper';
import ImageSwiper from './components/image-swiper';
import ScrollTo from './components/scroll-to';
import HighlightActiveSection from './components/highlight-active-section';
import Accordion from './components/accordion';
import Overlay from './components/overlay';
import HeroNavCover from './components/hero-nav-cover';
import ToggleFilters from './components/toggle-filters';
import RangeSwiper from './components/range-swiper';
import BCSFOverrides from './components/bcsf-overrides';
import IosBodyClass from './components/ios-body-class';
import AnimateOnEnter from './components/animate-on-enter';
import BGVideo from './components/bg-video';
import DeleteAddress from './components/delete-address';
import MaterialLibrary from './components/material-library';
import MaterialLibraryOverride from './components/material-library-override';
import wishlistMenu from './components/wishlist-menu';
import Form from './components/form';
import ImageGallery from './components/image-gallery';

import ProductCard from './components/product-card';
import ProductFMeasurements from './components/product-f-measurements';

import attachToggle from './components/custom-search-override';

HeroNavCover();
ReactComponents();
CurrencyRedirect();
PageHeader();
MegaMenu();
HeroHeader();
HeroSwiper();
RangeFilterOverrides();
MaterialSwiper();
PDPFurniture();
PDP();
CardSwiper();
ImageSwiper();
ScrollTo();
HighlightActiveSection();
Accordion();
Overlay();
ToggleFilters();
RangeSwiper();
BCSFOverrides();
IosBodyClass();
AnimateOnEnter();
BGVideo();
DeleteAddress();
MaterialLibrary();
MaterialLibraryOverride();
wishlistMenu();
Form();
ImageGallery();

ProductCard();
ProductFMeasurements();

attachToggle();